// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-footer {\n  text-align: center;\n  margin: 0.16rem 0;\n}\n", ""]);
// Exports
module.exports = exports;
